export class PointCounter {
  constructor(settings) {
    this.settings = settings;
  }

  // for calculation accuracy return float value
  calculatePointCount() {
    return undefined;
  }
}
